"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockTarget = blockTarget;
exports.getBlacklistPage = getBlacklistPage;
exports.unblockTarget = unblockTarget;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 分页查询黑名单
function getBlacklistPage(query) {
  return (0, _requestPIM.default)({
    url: '/rateLimitBlacklist/page',
    method: 'get',
    params: query
  });
}

// 手动封禁 (durationSeconds=0 表示永久)
function blockTarget(data) {
  return (0, _requestPIM.default)({
    url: '/rateLimitBlacklist/block',
    method: 'post',
    params: data
  });
}

// 解封
function unblockTarget(id) {
  return (0, _requestPIM.default)({
    url: '/rateLimitBlacklist/unblock/' + id,
    method: 'post'
  });
}